import { useNavigate } from "react-router-dom";

import ShortDeadlineIcon from "../../../assets/image/curto-prazo-icon.png";
import LongDeadline from "../../../assets/image/longo-prazo-icon.png";

import { useOtbViewModel } from "../../../viewModel/useOtbVewModel";

import { SectionHeader, OrderDetailsTable } from "../../../components/SharedComponents/sharedComponents.index";
import { Default } from "../../../components/Default/Default";
import { CustomText } from "../../../components/StyledComponents/styleComponents.index";
import { 
  HeaderWithFilters,
  HEADER_STRATEGY_CONSTANTS
} from "../../../viewModel/strategy/headers/HeaderWithFilters/headerWithFilters.strategy";

import { i18n } from "../../../translate/i18n";

import {
  InventoryBubbleMetrics,
  PerformanceChartVertical,
  Cards
} from "./components/performanceAnalysis.index";

import { GROUP_BY, MEDIAN_MODE, COMPANY_STORE_ID, OPPORTUNITY_STATUS } from "../../../components/components.constants";
import { ROUTES_APPLICATION_PATH } from "../../../routes.constants";

import { currencyFormatter, textFormatter } from "../../../utils/formatter/formatter";
import { useAnalysisViewModel } from "../../../viewModel/useAnalysysViewModel";

export function PerformanceAnalysisProduct() {
  
  const { t } = i18n
  const navigate = useNavigate();

  const vm = useOtbViewModel({ shouldFetchActiveOpp: OPPORTUNITY_STATUS.ACTIVE, shouldFetchInventory: true });
  const vmAnalysis = useAnalysisViewModel({ shouldFetchForecastData: true });

  return (
    <Default>
      <div           
        style={{
          display: "flex",
          flexDirection: "column",
          inlineSize: "100%",
          padding: "2rem 0 0 1rem"
        }}>
          
        <SectionHeader 
          ctx={{ 
            heading:  "Produto | Análise de Performance", 
            subtitles: [`${t("forecastGeneratedIn")} ${vmAnalysis.ctx.generationDate || "01/01/1970"}`],
            pageHeading: true
          }}
          uiState={{ headingSize: "lg" }}/>        

        <section style={{ borderBlockEnd: '1px solid #ccc', paddingBlock: '2rem' }}>
          <section style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBlockEnd: '2rem' }}>
            <CustomText color="black" weight="bold" textAlign="start" fontSize={['0.5rem', '1rem', '1.4rem']}>
              {'Impacto do Estoque na Venda'}
            </CustomText>
            <img
              src="/img/new/TargetProduct.png"
              alt="Ícone Impacto Estoque"
              style={{
                width: "44px",
                height: "44px",
                objectFit: "contain",
              }}
            />
          </section>

          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "2rem", marginBlockEnd: '1rem' }}>
            <section style={{ display:"flex", flexDirection:"row", gap: '18rem' }}>
              <Cards 
                actions={{ gotoPage: () => navigate(ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[2])}}
                ctx={{
                  cardLabel: t("replenishment"),
                  iconLabel: textFormatter(t("shortTerm"), { textTransform: 'uppercase' }),
                  imgIcon: ShortDeadlineIcon,
                  value: currencyFormatter.format(vm?.ctx?.lostSalesRiskSum || 0),
                  labels: {
                    btnLabel: t("actions"),
                    cardText: t("riskSalesLost")
                  }
                }}
              />

              <Cards 
                actions={{ gotoPage: () => navigate(ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[1]) }}
                ctx={{
                  cardLabel: t("purchase"),
                  iconLabel: textFormatter(t("longTerm"), { textTransform: 'uppercase' }),
                  imgIcon: LongDeadline,
                  value: currencyFormatter.format(vm?.ctx?.opportunityCounterData?.totalValue),
                  labels: {
                    btnLabel: t("actions"),
                    cardText: t("planAdjustmentOpp")
                  }
                }}
              />               
            </section>

          </div>  
        </section>

        <section style={{ 
          display: 'grid',
          borderBlockEnd: '1px solid #ccc', 
          gap: '2rem',
          gridTemplateColumns: '1fr',
          gridTemplateRows: '0.2fr 0.7fr',
          paddingBlock: '2rem' }}>

          <section style={{ blockSize: 'fit-content', display: 'grid', gridTemplateColumns: "5fr 1fr", paddingBlockStart: '1rem' }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: '2rem' }}>
              <CustomText color="black" weight="bold" textAlign="start" fontSize={['0.5rem', '1rem', '1.4rem']}>
                {t("currentInventoryView")}
              </CustomText>
              
              <img
                src="/img/new/SearchProduct.png"
                alt="Ícone Pesquisa"
                style={{
                  width: "44px",
                  height: "44px",
                  objectFit: "contain",
                }}/>
            </div>              

            <HeaderWithFilters 
              actions={{ setCurrentStoreData: vm?.actions?.setHorizon }}
              ctx={{
                data: vm?.ctx?.horizons,
                valueKey: "horizonId",
                labelKey: "horizonPeriod",
                labelPrefix: "",
                companyValue: vm?.ctx?.horizon,
                companyLabel: vm?.ctx?.horizons?.find(h => h.horizonId === vm?.ctx?.horizon)?.horizonPeriod,
                currentStoreId: COMPANY_STORE_ID.STORE_ID,
                labels: {
                  titlePage: t("period"),
                }
              }}
              uiState={{
                containerStyle: { 
                  display:"flex",
                  inlineSize: "fit-content",
                  alignItems: "baseline"
                }
              }}
              mode = {HEADER_STRATEGY_CONSTANTS.SINGLE_MODE}
            />
          </section>

          <div style={{ background: "#fff", borderRadius: "14px", boxShadow: "0 4px 10px rgba(0,0,0,0.06)", padding: "1.5rem 2rem", inlineSize: "100%" }}>
            <InventoryBubbleMetrics 
              ctx={{ 
                data: vm?.ctx?.inventoryBubbleMetrics || [], 
                medians: vm?.ctx?.medians || {},
                domains: vm?.ctx?.inventoryBubbleMetrics?.domains || null
              }}
              uiState={{ 
                groupBy: GROUP_BY.HORIZON,
                defaultHorizon: 6,
                mode: MEDIAN_MODE.FIXED,
                fixedMedianKey: '6'
              }}/>
          </div>

        </section>
          
        <section
          style={{
            background: "#fff",
            borderRadius: "14px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
            padding: "1.5rem 2rem",
            marginBlockStart: '3.6rem'
          }}
        >         
          <CustomText color="black" weight="bold" textAlign="start" fontSize={['0.5rem', '0.8rem', '1.4rem']}>
            {`Idade x Vendas: últimos 3 meses`}
          </CustomText>

          <div style={{ blockSize: '28rem', marginBlockStart: '2rem' }}>
            <PerformanceChartVertical ctx={{ data: vm?.ctx?.inventoryVsSales || []}} />
          </div>
        </section>

      </div>

    </Default>
  );
};